






















































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ProfileTeoWk',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
